import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { segmentTrack } from 'flow/actions/segment-actions';
import { generateSummary } from 'flow/actions/tickets-action';
import TicketSummaryItem from 'flow/components/tickets/event-item/TicketSummaryItem';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import { TicketKey } from 'flow/types/EntityKeys';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';

interface SummaryDTO {
    text: string;
}

interface Props {
    ticketKey?: TicketKey;
    summaryContext?: string;
}

const TicketSummaryModal = ({ ticketKey, summaryContext }: Props) => {
    const { i18next } = useAppContext();

    const dispatch = useAppDispatch();
    const [isFetching, setIsFetching] = useState(true);
    const [summary, setSummary] = useState('');

    useEffect(() => {
        setIsFetching(true);

        dispatch(
            segmentTrack(TICKET_STRINGS.GENERATE_SUMMARY_CLICK, {
                component: 'Generate summary modal',
            }),
        );

        dispatch(generateSummary(ticketKey, summaryContext))
            .then((response: SummaryDTO) => {
                setSummary(response.text);
                setIsFetching(false);
            })
            .catch(() => {
                setIsFetching(false);
            });
    }, [ticketKey, summaryContext, dispatch]);

    return (
        <BaseModal
            open={true}
            className="w-[600px]"
            header={
                <span className="ps-3 text-lg text-gray-800">
                    {i18next.t('ai.assistant')}
                </span>
            }
            disableActions={true}
        >
            <TicketSummaryItem
                summaryContext={summaryContext}
                ticketKey={ticketKey}
                isFetching={isFetching}
                summaryOriginal={summary}
            />
        </BaseModal>
    );
};

export default TicketSummaryModal;
